/**
 * build array of numbers between min and max
 * @param minNumber
 * @param maxNumber
 * @returns array of numbers between min and max
 * @deprecated will move to @coolcolduk/util
 */
export function buildArrayNumber(minNumber: number, maxNumber: number) {
  let result: number[] = [];
  for (let i = minNumber; i <= maxNumber; i++) {
    result.push(i);
  }
  return result;
}
